
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/[...path]",
      function () {
        return require("private-next-pages/locations/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locations/[...path]"])
      });
    }
  